// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expressionBuilderBody {
  background-color: white;
  height: 76%;
  overflow: auto;
  padding: 1% 3% 0% 3%;
}

.noRulesBody {
  background-color: white;
  height: 80%;
  overflow: auto;
  padding: 1%;
  text-align: center;
  border-radius: 0px 0px 10px 10px;
}

.expressionGroup {
  padding: 1%;
  border: 1px #17A0B4 solid;
  margin-bottom: 1%;
  border-radius: 10px 10px 10px 10px;
  height: 100%;
}

.expressionBuilderFooter {
  height: 7%;
  display: flex;
  align-items: center;
  padding-left: 1%;
  padding-right: 1%;
  padding-top: 1%;
  background-color: white;
  border-radius: 0px 0px 10px 10px;
}

.expression {
  padding-left: 1%;
  padding-right: 1%;
  font-weight: bold;
  font-size: 13px;
  box-sizing: border-box;
  height: 7%;
  width: 100%;
  background-color: #E8FCFF;
  display: flex;
  align-items: center;
}

.expression-builder {
  height: 7%;
  background-color: #17A2B8;
  display: flex;
  align-items: center;
  padding-left: 1%;
}

.build-expression-header {
  width: 97%;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.create-expression {
  height: 100%;
  width: 15%;
  display: flex;
  justify-content: center;
}

:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host ::ng-deep .mdc-text-field--focused,
:host ::ng-deep .mdc-text-field--filled,
:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
  --mdc-filled-text-field-focus-active-indicator-color: none !important;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input,
:host ::ng-deep .mat-mdc-form-field-type-mat-select {
  --mdc-filled-text-field-focus-label-text-color: black;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input .mat-mdc-form-field-subscript-wrapper,
:host ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .mat-mdc-form-field-infix {
  min-height: 40px !important;
  padding-top: 14px !important;
  padding-bottom: 6px !important;
}
:host ::ng-deep .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 3px 8px 3px 8px !important;
}
:host ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/expression-builder/expression-builder.component.scss"],"names":[],"mappings":"AAQA;EACI,uBAAA;EACA,WAAA;EACA,cAAA;EAEA,oBAAA;AARJ;;AAWA;EACI,uBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;AARJ;;AAWA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kCAAA;EACA,YAAA;AARJ;;AAWA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,gCAAA;AATJ;;AAYA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AATJ;;AAYA;EACI,UAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AATJ;;AAYA;EACI,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AATJ;;AAYA;EACI,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;AATJ;;AAcI;;;;EAII,iCAAA;EACA,qEAAA;AAXR;AAcI;;EAEI,qDAAA;AAZR;AAcQ;;EACI,wBAAA;AAXZ;AAeI;EACI,2BAAA;EACA,4BAAA;EACA,8BAAA;AAbR;AAgBI;EACI,mCAAA;AAdR;AAiBI;EACI,SAAA;AAfR","sourcesContent":["// select, select:focus-visible{\r\n//     border: none;\r\n//     // margin: 1%;\r\n//     border-bottom: 1px solid #74B1F1;\r\n//     outline: none;\r\n//     padding: 1%;\r\n// }\r\n\r\n.expressionBuilderBody {\r\n    background-color: white;\r\n    height: 76%;\r\n    overflow: auto;\r\n    // padding: 1%;\r\n    padding: 1% 3% 0% 3%;\r\n}\r\n\r\n.noRulesBody {\r\n    background-color: white;\r\n    height: 80%;\r\n    overflow: auto;\r\n    padding: 1%;\r\n    text-align: center;\r\n    border-radius: 0px 0px 10px 10px;\r\n}\r\n\r\n.expressionGroup {\r\n    padding: 1%;\r\n    border: 1px #17A0B4 solid;\r\n    margin-bottom: 1%;\r\n    border-radius: 10px 10px 10px 10px;\r\n    height: 100%;\r\n}\r\n\r\n.expressionBuilderFooter {\r\n    height: 7%;\r\n    display: flex;\r\n    align-items: center;\r\n    // justify-content: end;\r\n    padding-left: 1%;\r\n    padding-right: 1%;\r\n    padding-top: 1%;\r\n    background-color: white;\r\n    border-radius: 0px 0px 10px 10px;\r\n}\r\n\r\n.expression {\r\n    padding-left: 1%;\r\n    padding-right: 1%;\r\n    font-weight: bold;\r\n    font-size: 13px;\r\n    box-sizing: border-box;\r\n    height: 7%;\r\n    width: 100%;\r\n    background-color: #E8FCFF;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.expression-builder {\r\n    height: 7%;\r\n    background-color: #17A2B8;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 1%;\r\n}\r\n\r\n.build-expression-header {\r\n    width: 97%;\r\n    color: white;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.create-expression {\r\n    height: 100%;\r\n    width: 15%;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n:host ::ng-deep {\r\n\r\n    .mdc-text-field--filled:not(.mdc-text-field--disabled),\r\n    .mdc-text-field--focused,\r\n    .mdc-text-field--filled,\r\n    .mat-mdc-form-field {\r\n        background-color: #fff !important;\r\n        --mdc-filled-text-field-focus-active-indicator-color: none !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-type-mat-input,\r\n    .mat-mdc-form-field-type-mat-select {\r\n        --mdc-filled-text-field-focus-label-text-color: black;\r\n\r\n        .mat-mdc-form-field-subscript-wrapper {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n        min-height: 40px !important;\r\n        padding-top: 14px !important;\r\n        padding-bottom: 6px !important;\r\n    }\r\n\r\n    .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {\r\n        padding: 3px 8px 3px 8px !important;\r\n    }\r\n\r\n    .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\r\n        top: 22px\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
